import React, {
  useEffect,
  useMemo
} from "react";
import _ from "lodash";
import { useStore } from "react-redux";
import { useMappedState } from "redux-react-hook";

import {
  IFormOption,
  Select
} from "src/library/components/Forms";
import {
  usePricesApi,
  PricesRequestName
} from "src/core/prices/api/prices.api";
import { IStore } from "src/core/shared/store";

interface PriceListDropdownProps {
  updateSelectedPriceCode: (priceCodeId: number | null) => void;
  label?: string;
  additionalOptions?: IFormOption[];
  value?: number | null;
  special?: boolean;
  disabled?: boolean;
}

const PriceListDropdown: React.ReactFCWithChildren<PriceListDropdownProps> = ({
  updateSelectedPriceCode,
  additionalOptions = [],
  label = "Price List",
  value = 0,
  special = false,
  disabled
}) => {
  const [ priceCodesResponse, getPriceCodes ] = usePricesApi(PricesRequestName.LIST_PRICE_LISTS);
  const installedModules = useMappedState((store: IStore) => store.global.settings?.installedModules);
  const hasSpecialPriceModule = useMemo(() => installedModules?.includes("special-price"), [ installedModules ]);

  useEffect(() => {
    let filters = {};

    if (hasSpecialPriceModule) {
      filters = { special };
    }

    getPriceCodes({
      pagination: {
        page: 0,
        limit: 1000,
        offset: 0,
        sort: [ [ "name", "ASC" ] ]
      },
      filters
    });
  }, [
    special,
    getPriceCodes,
    hasSpecialPriceModule
  ]);

  return (
    <Select
      as="select"
      disabled={disabled}
      options={priceCodesResponse.data?.result ?
        [
          ..._.map(priceCodesResponse.data.result, priceCode => ({
            text: `${priceCode.code} - ${priceCode.name}`,
            value: priceCode.id.toString()
          })),
          ...additionalOptions
        ] :
        []}
      handleChange={e => {
        if (e.target.value.length) {
          updateSelectedPriceCode(parseInt(e.target.value));
        } else {
          updateSelectedPriceCode(null);
        }
      }}
      name="price-code-select"
      label={label}
      value={value?.toString()}
      unselectedOption={{
        text: "Please select",
        value: ""
      }}
    />
  );
};

export default PriceListDropdown;
